import { Box } from '@mui/material';
import React from 'react';
import PersonPinCircleIcon from '@mui/icons-material/PersonPinCircle';

export const AddressMapCrosshair: React.FC = () => (
    <Box
        position="absolute"
        top="50%"
        left="50%"
        sx={{ transform: 'translate(-50%, -100%)', pointerEvents: 'none' }}
    >
        <PersonPinCircleIcon sx={{ fontSize: '2rem' }} />
    </Box>
);
